import request from '@/router/axios';

const urlPrefix = process.env.VUE_APP_LOCAL_DEVELOPMENT == 'false' ? '/wage' : '/wage'

//分页查询操作模式列表信息
export function getPayGroupList(obj){
  return request({
    url: urlPrefix+'/payGroupSetting/queryListPageQuery',
    method: 'post',
    data: obj
  })
}
export function getGroupTree(obj){
  return request({
    url: urlPrefix + '/payGroupSetting/getGroupTree',
    method: 'post',
    data: obj
  })
}

//批量修改代码集状态
export function changeCodeSetStatus(obj){
  return request({
    url: urlPrefix + '/payGroupSetting/changePayGroupStatus',
    method: 'post',
    data: obj
  })
}
export function saveGroupDatas(obj){
  return request({
    url: urlPrefix + '/payGroupSetting/saveGroupDatas',
    method: 'post',
    data: obj
  })
}

//获取薪酬组下拉数据
export function getPayGroupData(obj){
  return request({
    url: urlPrefix + '/payGroupSetting/getPayGroupData',
    method: 'post',
    data: obj
  })
}
//获取薪酬组下拉数据
export function getPayGroupPIDData(obj){
  return request({
    url: urlPrefix + '/payGroupSetting/getPayGroupPIDData',
    method: 'post',
    data: obj
  })
}

//根据模板id，cusid获取模板项
export function getGroupInfo(groupId) {
  return request({
    url: urlPrefix + '/payGroupSetting/'+groupId,
    method: 'get',
  })
}
export function getGroupDatas(groupId) {
  return request({
    url: urlPrefix + '/payGroupSetting/getGroupDatas/'+groupId,
    method: 'get',
  })
}
//根据模板id，cusid获取模板项
export function getOrgDatas(groupId) {
  return request({
    url: urlPrefix + '/payGroupSetting/getOrgDatas/'+groupId,
    method: 'get',
  })
}
export function queryPersonListPage(obj) {
  return request({
    url: urlPrefix + '/payGroupSetting/queryPersonListPage',
    method: 'POST',
    data: obj,
  });
}
//获取当前客户信息
export function getCusData() {
  return request({
    url: urlPrefix + '/payGroupSetting/getCusData/',
    method: 'get',
  })
}
//获取机构数据
export function queryOrgTree(id) {
  return request({
    url: urlPrefix + '/payGroupSetting/queryOrgTree/'+id,
    method: 'get',
  });
}
//获取cusId机构数据,treeSelect
export function queryOrgTreeSelect(id) {
  return request({
    url: urlPrefix + '/payGroupSetting/treeSelect/'+id,
    method: 'get',
  });
}


//获取客户下的薪酬组树
export function getWageGroupTree(cusId) {
  return request({
    url: urlPrefix + '/payGroupSetting/getGroupTree',
    method: 'post',
    data:{cusId:cusId}
  });
}


//获取用户权限范围内的薪酬组树
export function queryPmsPayGroupTree() {
  return request({
    url: urlPrefix + '/payGroupSetting/queryPmsPayGroupTree',
    method: 'get',
  });
}


//校验薪酬组名称
export function checkGroupName(data) {
  return request({
    url: urlPrefix + '/payGroupSetting/checkGroupName',
    method: 'post',
    data:data
  });
}

//校验工资单是否重复
export function checkPaySettingAll(data) {
  return request({
    url: urlPrefix + '/payGroupSetting/checkPaySettingAll',
    method: 'post',
    data:data
  });
}

